var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading, id: "management" } }, [
    !_vm.userSignConfiguration.userSigns.length && _vm.isSigner
      ? _c("div", { staticClass: "text-center" }, [
          _c("h4", { staticClass: "text-danger" }, [
            _vm._v(
              " * Este usuario no tiene configurada su firma electrónica * "
            )
          ])
        ])
      : _vm._e(),
    _vm.fileOnFlow.detalle.ejecucion
      ? _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-1 position-relative text-center" }, [
              _vm.fileOnFlowAttachments.length
                ? _c(
                    "div",
                    { staticClass: "container-attachment" },
                    [
                      _vm._l(_vm.orderedFiles, function(attachment) {
                        return _c(
                          "div",
                          { key: attachment.url },
                          [
                            _c(
                              "vx-tooltip",
                              {
                                attrs: {
                                  text:
                                    "" +
                                    (attachment.nombreCompleto ||
                                      attachment.nombre),
                                  position: "right"
                                }
                              },
                              [
                                attachment &&
                                !attachment.esInicial &&
                                attachment.firmado
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btn-icon mt-2 text-center shadow",
                                        attrs: {
                                          variant: "outline-success",
                                          "data-cy": "signed-attachment"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFile(attachment)
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "FileIcon" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "vx-tooltip",
                              {
                                attrs: {
                                  text:
                                    "" +
                                    (attachment.nombreCompleto ||
                                      attachment.nombre),
                                  position: "right"
                                }
                              },
                              [
                                attachment &&
                                !attachment.esInicial &&
                                !attachment.firmado
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btn-icon mt-2 text-center shadow",
                                        attrs: {
                                          variant: "outline-primary",
                                          "data-cy": "attachment"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFile(attachment)
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "FileIcon" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "vx-tooltip",
                              {
                                attrs: {
                                  text:
                                    "" +
                                    (attachment.nombreCompleto ||
                                      attachment.nombre),
                                  position: "right"
                                }
                              },
                              [
                                attachment && attachment.esInicial
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "ripple",
                                            rawName: "v-ripple.400",
                                            value: "rgba(113, 102, 240, 0.15)",
                                            expression:
                                              "'rgba(113, 102, 240, 0.15)'",
                                            modifiers: { "400": true }
                                          }
                                        ],
                                        staticClass:
                                          "btn-icon mt-2 text-center shadow",
                                        attrs: {
                                          variant: "outline-warning",
                                          "data-cy": "main-attachment"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFile(attachment)
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "FileTextIcon" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "position-fixed manage-comments text-left m-auto"
                        },
                        [
                          _vm.selectedSign.proveedor !==
                            "FirmadorMinisterioEconomia" && _vm.showSignButton
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "h6",
                                    {
                                      staticClass: "my-2",
                                      staticStyle: { "font-size": "12px" }
                                    },
                                    [_vm._v(" Hey, estampa!! ")]
                                  ),
                                  _vm.showSignButton
                                    ? _c(
                                        "b-button",
                                        {
                                          ref: "signPosition",
                                          staticClass:
                                            "btn-icon rounded-circle shadow-lg sign-file",
                                          attrs: {
                                            variant: "warning",
                                            "data-cy": "stamp"
                                          },
                                          on: { click: _vm.setSign }
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "FeatherIcon" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isOffice && !_vm.isReservedFile
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "h6",
                                    {
                                      staticClass: "my-2 text-warning",
                                      staticStyle: { "font-size": "12px" }
                                    },
                                    [_vm._v(" privacidad ")]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(113, 102, 240, 0.15)",
                                          expression:
                                            "'rgba(113, 102, 240, 0.15)'",
                                          modifiers: { "400": true }
                                        }
                                      ],
                                      staticClass:
                                        "btn-icon rounded-circle shadow-lg",
                                      attrs: {
                                        variant: "outline-warning",
                                        "data-cy": "btn-privacy"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.markFile()
                                        }
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "LockIcon" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isOffice && _vm.participants.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "h6",
                                    {
                                      staticClass: "my-2 text-primary",
                                      staticStyle: { "font-size": "12px" }
                                    },
                                    [_vm._v(" destinos ")]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal",
                                          value: "modal-subjects",
                                          expression: "'modal-subjects'"
                                        },
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(113, 102, 240, 0.15)",
                                          expression:
                                            "'rgba(113, 102, 240, 0.15)'",
                                          modifiers: { "400": true }
                                        }
                                      ],
                                      staticClass:
                                        "btn-icon rounded-circle shadow-lg",
                                      attrs: {
                                        variant: "outline-info",
                                        "data-cy": "btn-destinations"
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "UsersIcon" }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("Subjects")
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "position-relative" },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass: "my-2",
                                  staticStyle: { "font-size": "12px" }
                                },
                                [_vm._v(" comentarios ")]
                              ),
                              _vm.haveComments
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "notification-indicator position-absolute",
                                      staticStyle: { "z-index": "100" },
                                      attrs: { "data-cy": "comment-indicator" }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.haveComments) + " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal",
                                      value: "modal-comments",
                                      expression: "'modal-comments'"
                                    },
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(113, 102, 240, 0.15)",
                                      expression: "'rgba(113, 102, 240, 0.15)'",
                                      modifiers: { "400": true }
                                    }
                                  ],
                                  staticClass:
                                    "btn-icon rounded-circle shadow-lg",
                                  attrs: {
                                    "data-cy": "bubble-comment",
                                    id: "toggle-btn",
                                    variant: "outline-primary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "MessageCircleIcon" }
                                  })
                                ],
                                1
                              ),
                              _vm.fileOnFlow.detalle &&
                              _vm.fileOnFlow.detalle.ejecucion
                                ? _c("Comments", {
                                    attrs: {
                                      comments:
                                        _vm.fileOnFlow.detalle.ejecucion
                                          .comentarios
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-7" }, [
              _vm.selectedFile
                ? _c(
                    "a",
                    {
                      class: {
                        "d-none":
                          _vm.isSiss && _vm.isReservedFile && _vm.isOffice
                      },
                      attrs: { href: _vm.selectedFile.url, target: "_blank" }
                    },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "text-primary underline d-inline-block mr-2",
                          attrs: { "data-cy": "document-viewer" }
                        },
                        [
                          _vm._v(
                            " * Visualizando documento seleccionado " +
                              _vm._s(_vm.selectedFile.nombreCompleto) +
                              " "
                          ),
                          _c("small", [
                            _vm._v("(" + _vm._s(_vm.selectedFile.nombre) + ")")
                          ]),
                          _vm._v(" * ")
                        ]
                      ),
                      _c("feather-icon", {
                        attrs: { icon: "ExternalLinkIcon" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.selectedFile
                ? _c("div", { staticClass: "shadow bg-gray" }, [
                    _vm.fileType === "pdf"
                      ? _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c("PdfViewport", {
                              ref: "pdfViewport",
                              attrs: {
                                "hide-document":
                                  _vm.isSiss &&
                                  _vm.isReservedFile &&
                                  _vm.isOffice,
                                "default-page": _vm.currentStepPage,
                                s3url: _vm.selectedFile.url,
                                name: _vm.selectedFile.nombreCompleto,
                                signatures: _vm.signatures,
                                "signature-width": _vm.signatureWidth,
                                "signature-height": _vm.signatureHeight
                              },
                              on: {
                                loaded: _vm.setSign,
                                "signature-drag-end": _vm.onSignatureDragEnd,
                                "signature-delete": _vm.closeSign
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.fileType === "image"
                      ? _c(
                          "div",
                          [
                            _c("b-img", {
                              attrs: {
                                src: _vm.selectedFile.url,
                                fluid: "",
                                alt: _vm.selectedFile.nombreCompleto
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.fileType === "docx"
                      ? _c("div", [
                          _c("iframe", {
                            attrs: {
                              src:
                                "https://portal.febos.cl/viewer/index.html?embedded=true&url=" +
                                encodeURIComponent(_vm.selectedFile.url),
                              width: "100%",
                              height: "600px"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c(
                  "b-card",
                  { staticClass: "shadow border-0 pt-0" },
                  [
                    _c("div", { staticClass: "bg-white pb-2" }, [
                      _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.ejecucion
                        ? _c("h5", { staticClass: "card-title mb-0" }, [
                            _vm._v(
                              " Expediente # " +
                                _vm._s(
                                  _vm.fileOnFlow.detalle.ejecucion.numero
                                ) +
                                " en el " +
                                _vm._s(
                                  _vm.fileOnFlow.detalle.ejecucion.nombre
                                ) +
                                " "
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "text-primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.fileOnFlow.detalle.ejecucion.descripcion
                            ) +
                            " "
                        )
                      ])
                    ]),
                    _c("b-card-body", { staticClass: "p-0" }, [
                      _c(
                        "div",
                        { staticClass: "mt-2 shadow" },
                        [
                          _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.pasos
                            ? _c("Steps", {
                                attrs: {
                                  steps: _vm.fileOnFlow.detalle.pasos,
                                  ejecucion: _vm.fileOnFlow.detalle.ejecucion
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.fileOnFlow.detalle
                        ? _c(
                            "div",
                            { staticClass: "mt-5 container-actions" },
                            [
                              _vm.fileType === "pdf" &&
                              _vm.fileLoaded &&
                              _vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      openConfigureSignModal:
                                        _vm.openConfigureSignModal,
                                      title: "Configurar firmas",
                                      action: "configure",
                                      newFlow: _vm.newFlow,
                                      color: "outline-success",
                                      "step-id": _vm.step
                                    },
                                    on: { "set-action": _vm.setAction }
                                  })
                                : _vm._e(),
                              _vm.isReviewer && _vm.isDocx && _vm.isEditable
                                ? _c("ManageDocument", {
                                    directives: [
                                      {
                                        name: "has-permission",
                                        rawName: "v-has-permission",
                                        value: "ED242",
                                        expression: "'ED242'"
                                      }
                                    ],
                                    attrs: {
                                      title: "Editar",
                                      action: "edit",
                                      newFlow: _vm.newFlow,
                                      openManageFlowModal:
                                        _vm.openManageFlowModal,
                                      color: "outline-warning",
                                      "step-id": _vm.step,
                                      attachment: _vm.principalEditionFile
                                    },
                                    on: { "set-action": _vm.setAction }
                                  })
                                : _vm._e(),
                              !_vm.isSigner && !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      openManageFlowModal:
                                        _vm.openManageFlowModal,
                                      title: _vm.getApprovalRolTitle,
                                      action: "approve",
                                      newFlow: _vm.newFlow,
                                      color: "outline-success",
                                      "step-id": _vm.step
                                    },
                                    on: { "set-action": _vm.setAction }
                                  })
                                : _vm._e(),
                              _vm.fileType === "pdf" &&
                              _vm.showSignButton &&
                              !_vm.toProcessFile &&
                              _vm.canSign &&
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.userSignConfiguration.userSigns
                                            .length,
                                        expression:
                                          "userSignConfiguration.userSigns.length"
                                      }
                                    ],
                                    attrs: {
                                      title: "Firmar Adjunto",
                                      action: "sign-attachment",
                                      "data-cy": "sign",
                                      newFlow: _vm.newFlow,
                                      color: "outline-success",
                                      "step-id": _vm.step,
                                      attachment: _vm.selectedFile,
                                      "get-sign": _vm.getPosition
                                    },
                                    on: { "set-action": _vm.setAction }
                                  })
                                : _vm._e(),
                              _vm.toProcessFile &&
                              _vm.isSigner &&
                              !_vm.isOffice &&
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.userSignConfiguration.userSigns
                                            .length,
                                        expression:
                                          "userSignConfiguration.userSigns.length"
                                      }
                                    ],
                                    attrs: {
                                      openManageFlowModal:
                                        _vm.openManageFlowModal,
                                      title: "Firmar",
                                      action: "sign",
                                      newFlow: _vm.newFlow,
                                      color: "outline-success",
                                      "data-cy": "sign",
                                      "step-id": _vm.step,
                                      "get-sign": _vm.getPosition
                                    },
                                    on: {
                                      "set-action": _vm.setAction,
                                      selectedSign: function($event) {
                                        _vm.selectedSign = $event
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.toProcessFile &&
                              _vm.isOffice &&
                              !_vm.isFileEDP &&
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.userSignConfiguration.userSigns
                                            .length,
                                        expression:
                                          "userSignConfiguration.userSigns.length"
                                      }
                                    ],
                                    attrs: {
                                      title: _vm.dynamicTitle,
                                      action: "manage",
                                      color: "outline-success",
                                      process: _vm.isOffice,
                                      "step-id": _vm.step,
                                      "get-sign": _vm.getPosition
                                    }
                                  })
                                : _vm._e(),
                              _vm.isFileEDP &&
                              _vm.toProcessFile &&
                              _vm.isOffice &&
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      title: "Entregar fecha",
                                      action: "manage-date",
                                      color: "outline-success",
                                      "step-id": _vm.step,
                                      "get-sign": _vm.getPosition
                                    }
                                  })
                                : _vm._e(),
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      title: "Rechazar",
                                      openManageFlowModal:
                                        _vm.openManageFlowModal,
                                      action: "reject",
                                      newFlow: _vm.newFlow,
                                      color: "outline-danger",
                                      "step-id": _vm.step
                                    },
                                    on: { "set-action": _vm.setAction }
                                  })
                                : _vm._e(),
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      title: "Reenviar",
                                      action: "resend",
                                      "is-signer": _vm.isSigner,
                                      "has-signature-positon":
                                        _vm.hasSignaturePosition,
                                      newFlow: _vm.newFlow,
                                      color: "outline-info",
                                      "step-id": _vm.step
                                    },
                                    on: { "set-action": _vm.setAction }
                                  })
                                : _vm._e(),
                              ((_vm.canReturn &&
                                !_vm.haveExternStepProcessed) ||
                                (_vm.isOffice && !_vm.isGore)) &&
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      title: "Devolver",
                                      action: "return",
                                      color: "outline-warning",
                                      "step-id": _vm.step
                                    }
                                  })
                                : _vm._e(),
                              !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      title: "Comentar",
                                      action: "comment",
                                      color: "outline-secondary",
                                      "step-id": _vm.step,
                                      modal: "comment"
                                    }
                                  })
                                : _vm._e(),
                              _vm.enableAttach && !_vm.isConfigurator
                                ? _c("ManageDocument", {
                                    attrs: {
                                      title: "Adjuntar",
                                      action: "attach",
                                      color: "outline-secondary",
                                      "step-id": _vm.step,
                                      modal: "comment"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm.action &&
            _vm.showModalConsequence &&
            _vm.consequenceType &&
            _vm.processConsequence && Object.keys(_vm.processConsequence).length
              ? _c(
                  "b-modal",
                  {
                    ref: "modal-consequence",
                    attrs: {
                      "hide-header-close": "",
                      "ok-only": "",
                      "no-close-on-backdrop": "",
                      id: "modal-consequence",
                      title: "Consecuencia del documento",
                      "data-cy": "modal-consequence-document",
                      "ok-title": "Aceptar",
                      size: "xl"
                    },
                    on: { ok: _vm.handleOk }
                  },
                  [
                    !_vm.openManageFlowModal && _vm.showModalConsequence
                      ? _c("div", [
                          _vm.consequenceType.nombre === "gatilladorFlujo"
                            ? _c("h3", [
                                _vm._v(
                                  " Redirigir flujo a un flujo predefinido "
                                )
                              ])
                            : _vm._e(),
                          _vm.processConsequence.configuracion.cambia_flujo &&
                          _vm.processConsequence.configuracion.cambia_flujo ===
                            "si"
                            ? _c("div", [
                                _c("h5", [
                                  _vm._v(
                                    " Por favor selecciona el flujo al que será reenviado "
                                  )
                                ]),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "v-select",
                                      {
                                        attrs: {
                                          options:
                                            _vm.filteredApprovalsTemplates,
                                          name: "flow-select",
                                          label: "nombre",
                                          "data-cy": "select-template",
                                          placeholder: "Selecciona el flujo",
                                          reduce: function(option) {
                                            return option.id
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.newFlow
                                              .aprobacionesReferenciaId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.newFlow,
                                              "aprobacionesReferenciaId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "newFlow.aprobacionesReferenciaId"
                                        }
                                      },
                                      [
                                        _c("template", { slot: "no-options" }, [
                                          _vm._v(" no hay flujos ")
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _c("hr")
                              ])
                            : _vm._e(),
                          _vm.consequenceType.nombre === "gatilladorFlujoOnFly"
                            ? _c(
                                "h3",
                                {
                                  staticClass: "uk-modal-title",
                                  staticStyle: { color: "#e4501e" }
                                },
                                [
                                  _vm._v(
                                    " Redirigir flujo a un flujo on the fly "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.processConsequence.configuracion
                            .seleccion_conductor == "si"
                            ? _c(
                                "div",
                                [
                                  _c("h5", [
                                    _vm._v(
                                      "Por favor, selecciona el archivo que será el principal para el flujo"
                                    )
                                  ]),
                                  _vm._l(_vm.fileOnFlowAttachments, function(
                                    attachment
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: attachment.url,
                                        staticClass:
                                          "d-flex justify-content-between mt-2"
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "strong",
                                            [
                                              _c("vs-icon", {
                                                attrs: {
                                                  icon: "description",
                                                  size: "15px",
                                                  color: "primary"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          attachment.nombreCompleto
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    attachment.nombreCompleto
                                                  )
                                                )
                                              ])
                                            : _c("span", [_vm._v("Adjunto")]),
                                          attachment.clasificacion
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    attachment.clasificacion
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        !_vm.newFlow.documentos.length ||
                                        _vm.newFlow.documentos[0].url !=
                                          attachment.url
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  size: "sm",
                                                  variant: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectPrincipalAttachment(
                                                      attachment
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" seleccionar ")]
                                            )
                                          : _vm._e(),
                                        _vm.newFlow.documentos.length &&
                                        _vm.newFlow.documentos[0].url ==
                                          attachment.url
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  size: "sm",
                                                  variant: "success"
                                                }
                                              },
                                              [_vm._v(" seleccionado ")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.processConsequence.configuracion
                            .seleccion_conductor == "si"
                            ? _c("hr")
                            : _vm._e(),
                          !_vm.onlyAttatchments.length
                            ? _c("div", [
                                _vm._v(
                                  " No hay documentos adjuntos para elegir "
                                )
                              ])
                            : _vm._e(),
                          _vm.processConsequence.configuracion.adjuntos &&
                          _vm.processConsequence.configuracion.adjuntos ==
                            "selecciona" &&
                          _vm.onlyAttatchments.length
                            ? _c(
                                "div",
                                { staticClass: "wrap-content" },
                                [
                                  _c("h5", [
                                    _vm._v(
                                      "Por favor, selecciona los archivos que formarán parte del otro flujo"
                                    )
                                  ]),
                                  _vm._l(_vm.newFlow.adjuntos, function(
                                    attachmentFlow
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: attachmentFlow.url,
                                        staticClass: "row",
                                        staticStyle: {
                                          "border-bottom": "1px solid #c6ebfb",
                                          "padding-bottom": "4px"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: " col-6 mt-3" },
                                          [
                                            _c(
                                              "span",
                                              {},
                                              [
                                                _c("vs-icon", {
                                                  attrs: {
                                                    icon: "description",
                                                    size: "15px",
                                                    color: "primary"
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        !!attachmentFlow.nombreCompleto
                                                          ? attachmentFlow.nombreCompleto
                                                          : "Adjunto"
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-6 text-right mt-3"
                                          },
                                          [
                                            !attachmentFlow.seleccionado
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.selectAttachment(
                                                          attachmentFlow
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" seleccionar ")]
                                                )
                                              : _vm._e(),
                                            attachmentFlow.seleccionado
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeAttachment(
                                                          attachmentFlow
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" seleccionado ")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.processConsequence.configuracion.adjuntos &&
                          _vm.processConsequence.configuracion.adjuntos ==
                            "selecciona"
                            ? _c("hr")
                            : _vm._e(),
                          _vm.consequenceType.nombre === "gatilladorFlujoOnFly"
                            ? _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c("h5", [
                                      _vm._v("Configuración de pasos")
                                    ]),
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table text-center table-responsive",
                                        staticStyle: { width: "100%" }
                                      },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { staticClass: " text-center" },
                                              [_vm._v("Tipo")]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: " text-center" },
                                              [_vm._v("Responsable")]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: " text-center" },
                                              [_vm._v("Rol")]
                                            ),
                                            _c("th", {
                                              staticClass: " text-center"
                                            })
                                          ])
                                        ]),
                                        _c(
                                          "tbody",
                                          _vm._l(_vm.newFlow.pasos, function(
                                            responsable,
                                            index
                                          ) {
                                            return _c(
                                              "tr",
                                              {
                                                key: "responsable-" + index,
                                                staticClass: "text-center"
                                              },
                                              [
                                                _c("td", [
                                                  _vm.stepTypesMixing.USER ==
                                                  responsable.tipoPasoId
                                                    ? _c("span", [
                                                        _vm._v("Usuario")
                                                      ])
                                                    : _vm._e(),
                                                  _vm.stepTypesMixing.GROUP ==
                                                  responsable.tipoPasoId
                                                    ? _c("span", [
                                                        _vm._v("Grupo")
                                                      ])
                                                    : _vm._e()
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(responsable.nombre)
                                                  )
                                                ]),
                                                _c("td", [
                                                  _vm.rolTypesObject[
                                                    responsable.rolId
                                                  ]
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .rolTypesObject[
                                                                responsable
                                                                  .rolId
                                                              ]
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]),
                                                _c(
                                                  "td",
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value:
                                                              "Remover paso",
                                                            expression:
                                                              "'Remover paso'"
                                                          }
                                                        ],
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeResponsible(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("vs-icon", {
                                                          attrs: {
                                                            icon: "delete",
                                                            size: "15px"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-12 mt-2" }, [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table text-center table-responsive",
                                        staticStyle: {
                                          width: "100%",
                                          "border-top": "1px solid #a3a3a3"
                                        }
                                      },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { staticClass: " text-center" },
                                              [_vm._v("Tipo")]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: " text-center" },
                                              [_vm._v("Responsable")]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: " text-center" },
                                              [_vm._v("Rol")]
                                            ),
                                            _c("th", {
                                              staticClass: " text-center"
                                            })
                                          ])
                                        ]),
                                        _c("tbody", [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              [
                                                _c(
                                                  "vs-select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    ref: "stepType",
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      autocomplete: "",
                                                      label: "Tipo de paso",
                                                      name: "stepType",
                                                      danger: _vm.errors.has(
                                                        "newFlowStep.stepType"
                                                      ),
                                                      "danger-text": _vm.errors.first(
                                                        "newFlowStep.stepType"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newFlowStep
                                                          .tipoPasoId,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newFlowStep,
                                                          "tipoPasoId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newFlowStep.tipoPasoId"
                                                    }
                                                  },
                                                  [
                                                    _c("vs-select-item", {
                                                      attrs: {
                                                        value: "1",
                                                        text: "Grupo"
                                                      }
                                                    }),
                                                    _c("vs-select-item", {
                                                      attrs: {
                                                        value: "2",
                                                        text: "Usuario"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              [
                                                _vm.newFlowStep.tipoPasoId ==
                                                _vm.stepTypesMixing.GROUP
                                                  ? _c("list-groups", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              _vm.newFlowStep
                                                                .stepType ===
                                                              _vm
                                                                .stepTypesMixing
                                                                .GROUP
                                                          },
                                                          expression:
                                                            "{ required: newFlowStep.stepType === stepTypesMixing.GROUP }"
                                                        }
                                                      ],
                                                      ref: "groupStep",
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        autocomplete: "",
                                                        label:
                                                          "Grupo del responsable",
                                                        name: "groupStep",
                                                        typeList:
                                                          _vm.newFlowStep
                                                            .stepType,
                                                        danger: _vm.errors.has(
                                                          "newFlowStep.stepType"
                                                        ),
                                                        "danger-text": _vm.errors.first(
                                                          "newFlowStep.stepType"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newFlowStep
                                                            .responsableId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newFlowStep,
                                                            "responsableId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newFlowStep.responsableId"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm.newFlowStep.tipoPasoId ==
                                                _vm.stepTypesMixing.USER
                                                  ? _c("list-user", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              _vm.newFlowStep
                                                                .stepType ===
                                                              _vm
                                                                .stepTypesMixing
                                                                .USER
                                                          },
                                                          expression:
                                                            "{ required: newFlowStep.stepType === stepTypesMixing.USER }"
                                                        }
                                                      ],
                                                      ref: "userStep",
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        autocomplete: "",
                                                        label:
                                                          "Responsable del paso",
                                                        name: "userStep",
                                                        danger: _vm.errors.has(
                                                          "newFlowStep.responsableId"
                                                        ),
                                                        "danger-text": _vm.errors.first(
                                                          "newFlowStep.responsableId"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newFlowStep
                                                            .responsableId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newFlowStep,
                                                            "responsableId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newFlowStep.responsableId"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              [
                                                _c(
                                                  "vs-select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    ref: "stepType",
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      autocomplete: "",
                                                      label: "Tipo de paso",
                                                      name: "stepType",
                                                      danger: _vm.errors.has(
                                                        "newFlowStep.rolId"
                                                      ),
                                                      "danger-text": _vm.errors.first(
                                                        "newFlowStep.rolId"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newFlowStep.rolId,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newFlowStep,
                                                          "rolId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newFlowStep.rolId"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.rolTypesAvalaibles,
                                                    function(type) {
                                                      return _c(
                                                        "vs-select-item",
                                                        {
                                                          key: type.opcionId,
                                                          attrs: {
                                                            value: type.valor,
                                                            text:
                                                              type.descripcion
                                                          }
                                                        }
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  "text-align": "center"
                                                }
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success",
                                                      size: "sm"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addStepOnFly(
                                                          _vm.newFlowStep
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" Agregar ")]
                                                )
                                              ],
                                              1
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm.errorConsequence
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "error-message mt-3 text-danger text-right"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.errorConsequence) + " "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }